import {
	FormSelect as FormSelectDS,
	type FormSelectProps as FormSelectPropsDS,
} from '@gov-design-system-ce/react-form';
import type { CommonSelectProps } from '@gov-nx/ui/types';
import { MessageWrapper } from './MessageWrapper';

export interface FormSelectProps extends Omit<
	FormSelectPropsDS,
	'messageWrapper' | 'classNames'
> {}

export const FormSelect = (props: FormSelectProps) => (
	<FormSelectDS
		{...props}
		label={{ size: 'm', ...props.label }}
		field={{ size: 'm', ...props.field }}
		messages={props.messages ?? { messages: [] }}
		messageWrapper={MessageWrapper}
	/>
);

export const optionsToChildren = (
	options: { value: string | number; label: string; isDisabled?: boolean }[]
) => (
	<>
		{options.map((option) => (
			<option
				key={[option.value, option.label].join('-')}
				value={option.value}
				disabled={option.isDisabled}>
				{option.label}
			</option>
		))}
	</>
);

export const commonSelectPropsToSelectProps = (
	props: CommonSelectProps
): FormSelectProps => ({
	field: { ...props.field, children: optionsToChildren(props.field.options) },
	label: props.label,
	messages: props.messages,
});
